import { render, staticRenderFns } from "./centers.vue?vue&type=template&id=b81eda94&"
import script from "./centers.vue?vue&type=script&lang=js&"
export * from "./centers.vue?vue&type=script&lang=js&"
import style0 from "./centers.vue?vue&type=style&index=0&id=b81eda94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports